import { baseResourceOptions } from './utils';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import createCollectionResource from '../shared/createResource';
import { SidekickRevision } from 'src/models/Sidekick/SidekickRevision';

const sidekickRevisionsResource = createCollectionResource<SidekickRevision>({
  name: 'sidekickRevisions',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flow-revisions/:id',
  type: SidekickRevision,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickRevisionsResource;
